"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericError = exports.getUidsFromButton = exports.getActiveUids = exports.getUids = exports.getUidsFromId = exports.createIconButton = exports.addButtonListener = void 0;
const writes_1 = require("./writes");
/**
 * TODO: Replace this paradigm with an attr config instead.
 */
const getButtonConfig = (target, targetCommand) => {
    const rawParts = target.innerText
        .substring(targetCommand.length + 1)
        .split(" ");
    let quotedWord = "";
    const restOfButtonText = [];
    for (const part of rawParts) {
        if (quotedWord) {
            if (part.endsWith('"')) {
                restOfButtonText.push(`${quotedWord} ${part.substring(0, part.length - 1)}`);
                quotedWord = "";
            }
            else {
                quotedWord = `${quotedWord} ${part}`;
            }
        }
        else {
            if (part.startsWith('"')) {
                quotedWord = part.substring(1);
            }
            else {
                restOfButtonText.push(part);
            }
        }
    }
    const numPairs = Math.floor(restOfButtonText.length / 2);
    const buttonConfig = {};
    for (let i = 0; i < numPairs; i++) {
        buttonConfig[restOfButtonText[i * 2]] = restOfButtonText[i * 2 + 1];
    }
    return buttonConfig;
};
const clickEventListener = (targetCommand, callback) => (e) => __awaiter(void 0, void 0, void 0, function* () {
    const htmlTarget = e.target;
    if (htmlTarget &&
        htmlTarget.tagName === "BUTTON" &&
        htmlTarget.innerText
            .toUpperCase()
            .trim()
            .startsWith(targetCommand.toUpperCase())) {
        const target = htmlTarget;
        const buttonConfig = getButtonConfig(target, targetCommand);
        const { blockUid } = exports.getUidsFromButton(target);
        window.roamAlphaAPI.updateBlock({ block: { uid: blockUid, string: "" } });
        callback(buttonConfig, blockUid);
    }
});
const addButtonListener = (targetCommand, callback) => document.addEventListener("click", clickEventListener(targetCommand, callback));
exports.addButtonListener = addButtonListener;
/**
 * @param icon A blueprint icon which could be found in https://blueprintjs.com/docs/#icons
 */
const createIconButton = (icon) => {
    const popoverButton = document.createElement("span");
    popoverButton.className = "bp3-button bp3-minimal bp3-small";
    popoverButton.tabIndex = 0;
    const popoverIcon = document.createElement("span");
    popoverIcon.className = `bp3-icon bp3-icon-${icon}`;
    popoverButton.appendChild(popoverIcon);
    return popoverButton;
};
exports.createIconButton = createIconButton;
const getUidsFromId = (id) => {
    const blockUid = id.substring(id.length - 9, id.length);
    const restOfHTMLId = id.substring(0, id.length - 9);
    const potentialDateUid = restOfHTMLId.substring(restOfHTMLId.length - 11, restOfHTMLId.length - 1);
    const parentUid = isNaN(new Date(potentialDateUid).valueOf())
        ? potentialDateUid.substring(1)
        : potentialDateUid;
    return {
        blockUid,
        parentUid,
    };
};
exports.getUidsFromId = getUidsFromId;
const getUids = (block) => {
    return block ? exports.getUidsFromId(block.id) : { blockUid: "", parentUid: "" };
};
exports.getUids = getUids;
const getActiveUids = () => exports.getUids(document.activeElement);
exports.getActiveUids = getActiveUids;
const getUidsFromButton = (button) => {
    const block = button.closest(".roam-block");
    return block ? exports.getUids(block) : { blockUid: "", parentUid: "" };
};
exports.getUidsFromButton = getUidsFromButton;
const genericError = (e) => {
    const message = (e.response
        ? typeof e.response.data === "string"
            ? e.response.data
            : JSON.stringify(e.response.data)
        : e.message) ||
        e.raw ||
        "Unknown Error Occurred";
    writes_1.updateActiveBlock(`Error: ${message.length > 50 ? `${message.substring(0, 50)}...` : message}`);
};
exports.genericError = genericError;
